export default __webpack_public_path__ + "static/media/coi-prime.2d0381c3.png";